import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-turns-new-location',
  templateUrl: './turns-new-location.component.html',
  styleUrls: ['./turns-new-location.component.scss']
})
export class TurnsNewLocationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
